<!-- Line Details -->
<!-- :title="$t('line_details_modal.title', {id: currentLine.index})" -->
<template>
    <b-modal
      v-if="currentLine != null"
      :visible="visible"
      @hidden="hide"       
      @change="change"
      scrollable
      ref="modal_line_details"
      id="modal-line-details"
      no-close-on-backdrop      
      :title="$t('line_details_modal.title')"
      :ok-only="true" 
      :ok-title="$t('close')" 
    >
    <b-row>
      <b-col cols="4"><div class="numberLineModal">{{parseInt(currentLine.line_num ? currentLine.line_num : currentLine.index)}}</div></b-col>
      <b-col cols="8">
        <b-row>
          <b-col cols="12">
            {{$t("details_cu_modal.cu_descrizione")}}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col v-if="!editingLineLocal" cols="9" sm="10"><strong>
                {{ nomeLineAttuale }}</strong></b-col>
              <b-col v-if="!editingLineLocal" cols="3" sm="2"><b-button @click="editNomeLine"><i
                  class="fa fa-edit"></i></b-button></b-col>
              <!-- <b-col v-else cols="3" sm="2"></b-col> -->
              <b-col v-if="editingLineLocal" cols="7" sm="8">
                <div role="group">
                  <b-form-input id="lineName" type="text" v-model="nomeLine" :maxlength="maxchar"></b-form-input>
                  <b-form-text v-html="lineNameInfo()"></b-form-text>
                </div>
              </b-col>
              <b-col v-if="editingLineLocal" cols="5" sm="4">
                <b-button v-if="!updatingNameLocal" @click="saveNomeLine"><i class="fa fa-check"></i></b-button>
                <b-button v-if="!updatingNameLocal" @click="abortNomeLine"><i class="fa fa-close"></i></b-button>
                <span v-if="updatingNameLocal"><i class="fa fa-spinner fa-spin"></i></span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
        
    </b-row>

    <hr>
<!-- Errors found -->
    <b-row ><b-col cols="12" offset-sm="1" sm="10"><strong>{{$t("details_cu_modal.cu_error")}}</strong></b-col></b-row>
      <b-row v-if='currentLine.error_com_cpu_ak=="ON"'><b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.error_communication")}}</b-col></b-row>
      <div v-else>
        <b-row v-if='currentLine.error_ak_su_current=="ON"'><b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.error_ak_su_current")}}</b-col></b-row>      
        <b-row v-if='currentLine.error_line_fuse=="ON"'><b-col scols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.error_fuse")}}</b-col></b-row>
        <b-row v-if='currentLine.error_line_isolation=="ON"'><b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.error_isolation")}}</b-col></b-row>
        <b-row v-if="currentLine.num_lamp_error != 0"><b-col cols="12" offset-sm="1"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("details_cu_modal.cu_error_lg")}}</b-col></b-row>
      </div>
      <b-row v-if="(NessunErrore(currentLine)) && (currentLine.num_lamp_error == 0)">
          <b-col cols="12" offset-sm="1"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("charger.no_error")}}</b-col>
      </b-row>

    </b-modal>
</template>

<script>
// import Vue from 'vue'

export default {
  name: "LineDetails",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    currentCent: null,
    currentLine: null,
    scanning: false,
    visible: {
      type: Boolean,
      default: false
    },
    sendAction: Function
  },

  emits:['hide', 'change', 'updating'],

  data() {
    return {
        pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
        pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                       //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
        isVisible: false, //*
        updatingNameLocal: false,
        editingLineLocal: false,
        nomeLine: this.currentLine ? this.currentLine.line_desc : "",
        maxchar: 30,
    };
  },

  computed: {
    nomeLineAttuale()
    {
      return this.currentLine.line_desc;
    },
  },

  created() {
  },
  mounted() {
  },

  methods: {
    //restituisce un messaggio html con i caratteri introdotti per la descrizione della linea
    lineNameInfo() {
      const nl = this.nomeLine.length;
      //const validChars = /^[\x20-\x7F]*$/.test(this.nomeLamp);
      const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeLine);
      if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
      if (nl > 30 || !validChars)
      {
        return "<b style=\"color:red\">" + nl + "/30 Caratteri</b>";
      }
      return "" + nl + "/30 Caratteri";
    },
    //salva il nome della linea
    saveNomeLine() {
      var params = {};
      console.log("SaveNomeLine, currentCent: ", this.currentCent, " currentLine: ", this.currentLine);
      params.command = "setLineDesc";
      params.cu_type = this.currentCent.cu_type;
      params.cu_id = this.currentCent.cu_id;
      params.lines = [];
      params.num_lines = 1;
      params.lines[0] = { id: this.currentLine.index, name: this.nomeLine };
      this.updatingNameLocal = true;
      this.sendAction(params);        
    },
    abortNomeLine() {
      this.editingLineLocal = false;
    },

    editNomeLine() {
      if (this.currentLine.desc != null) {
        this.nomeLine = this.currentLine.line_desc;
      }
      else {
        this.nomeLine = "";
      }
      this.editingLineLocal = true;
    },
    //cerca nelle properties dell'oggetto disp, isola quelle che contengono 'error_' (per evitare num_lamp_error) e verifica se il valore è ON
    NessunErrore(disp) {
        let noerrore = true
        for (const property in disp)
        {
            if ((property.includes("error_")) && (disp[property] === "ON"))
            {
                noerrore = false;
            }
        }
        return noerrore;     
    },

    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible) {
        // console.log("MASSI01: change visible", visible)
        this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide() {
        // console.log("MASSI02: emesso hide")
         this.$emit("hide");
    },

  }
}
</script>

<style lang="scss">
  li {
    list-style: none;
  }
  #tab_advanced .nav-tabs{
        font-weight: bold;
    }
  .typo-data{
    font-weight:400;
    font-family: Roboto;
    font-size: 13px;
  }
  .numberLineModal {
    border-radius: 10%;
    width: 70px;
    height: 70px;
    background: #0090CD;
    border: 2px solid #0090CD;
    color: #FFF;
    // text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font: 20px Arial, sans-serif, bold;
}
</style>